
<div>
    <c-inspection-data
        :has-data    = "hasData"
        :show-header = "false"
        :height      = "height"
        :title       = "$t('disposition.sticker.menu')"
    >
        <template v-slot:header>
        </template>

        <template v-slot:body>
            <div class="pl-3">
                <v-row v-if="hasData" dense class="primary--text data-title" style="margin-top: -2px; border-top-left-radius: 4px; border-top-right-radius: 4px; font-size: 14px; ">
                    <v-col class="col-6 pl-2">
                        QR Code
                    </v-col>
                    <v-col class="col-3">
                        Plazierung
                    </v-col>
                    <v-col class="col-3">
                        Etage
                    </v-col>
                </v-row>

                <v-row dense v-for="(sticker, index) in inspection.stickers.stickers" :key="index" class="table-row">
                    <v-col class="col-6 pl-2">
                        {{ sticker.uuid }}
                    </v-col>
                    <v-col class="col-3">
                        {{ type (sticker) }}
                    </v-col>

                    <v-col class="col-3">
                        {{ sticker.type === "CAR" ? null : sticker.floor }}
                    </v-col>
                </v-row>
            </div>
        </template>
    </c-inspection-data>
</div>
